// extracted by mini-css-extract-plugin
module.exports = {"modal-dialog":"v_cd","modalDialog":"v_cd","modal-title":"v_cf","modalTitle":"v_cf","modal-subtitle":"v_cg","modalSubtitle":"v_cg"};